import { render, staticRenderFns } from "./chat-financeiro.vue?vue&type=template&id=5098eff8&scoped=true"
import script from "./chat-financeiro.ts?vue&type=script&lang=ts&external"
export * from "./chat-financeiro.ts?vue&type=script&lang=ts&external"
import style0 from "./chat-financeiro.scss?vue&type=style&index=0&id=5098eff8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098eff8",
  null
  
)

export default component.exports